
<!-- ORANGE TOP RIBBON — only place #F37022 is used -->

<!-- ===== HERO ===== -->
<section class="ce-hero">
  <div class="ce-wrap">
    <div class="ce-hero-grid">
      <div>
        <span class="ce-eyebrow"><i class="fa-solid fa-location-dot"></i> Chelmsford Exam Centre</span>
        <h1>Chelmsford 11+ <em>CSSE &amp; FSCE/CCHS</em> Mock Exams</h1>
        <p class="ce-hero-schools ce-hero-schools-top">For <b>KEGS • CCHS • CRGS • Westcliff • Southend</b> &amp; other Essex selective schools</p>
        <p class="ce-hero-lede">Real exam conditions. Cohort ranking, percentile &amp; standardised score. Detailed performance analysis. See exactly where your child stands before the real 11+.</p>
        <div class="ce-hero-pills">
          <span class="ce-hero-pill"><i class="fa-solid fa-clock"></i> Full exam-condition timing</span>
          <span class="ce-hero-pill"><i class="fa-solid fa-chart-column"></i> Rank, Percentile &amp; SS</span>
          <span class="ce-hero-pill"><i class="fa-solid fa-arrow-trend-up"></i> Exam Prediction</span>
          <span class="ce-hero-pill"><i class="fa-solid fa-file-lines"></i> Take-Home Paper</span>
        </div>
        <div class="ce-hero-ctas">
          <a href="https://www.sehyog.co.uk/11plus-mock-test" class="ce-btn ce-btn-primary"><i class="fa-solid fa-calendar-check"></i> Book Your Chelmsford Mock</a>
          <a href="#ce-report" class="ce-btn ce-btn-outline" (click)="scrollToReport($event)">See a Sample Report</a>
        </div>
      </div>
      <div class="ce-hero-img-wrap">
        <div class="ce-hero-img">
          <img src="https://images.unsplash.com/photo-1649920442906-3c8ef428fb6e?auto=format&fit=crop&w=1200&q=80" alt="English school students in a UK classroom sitting an 11+ mock exam under exam conditions" loading="lazy">
        </div>
        <div class="ce-hero-float">
          <div class="ce-hero-float-head">
            <strong>Cohort Performance Report</strong>
            <small>Rank • Percentile • Standardised Score</small>
          </div>
          <div class="ce-hero-float-stats">
            <div class="ce-hf-stat"><span class="ce-hf-val">#18</span><span class="ce-hf-label">Rank</span></div>
            <div class="ce-hf-stat"><span class="ce-hf-val">87th</span><span class="ce-hf-label">Percentile</span></div>
            <div class="ce-hf-stat"><span class="ce-hf-val">121</span><span class="ce-hf-label">SS</span></div>
          </div>
          <p class="ce-hero-float-foot">Included in every SEHYOG mock report</p>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ===== TRUST BAR ===== -->
<div class="ce-trust-bar">
  <div class="ce-wrap ce-trust-row">
    <div><i class="fa-solid fa-users"></i> 10,000+ Students Supported</div>
    <div><i class="fa-solid fa-award"></i> 11+ Specialists Since 2015</div>
    <div><i class="fa-solid fa-certificate"></i> CSSE &amp; FSCE Specialists</div>
    <div><i class="fa-solid fa-star"></i> 2025 Essex CSSE Top Score: 419.11</div>
  </div>
</div>

<!-- ===== NEXT AVAILABLE MOCKS (full schedule, table format) ===== -->
<section class="ce-section" id="ce-next-mocks">
  <div class="ce-wrap">
    <span class="ce-eyebrow"><i class="fa-solid fa-bolt"></i> Booking Fills Fast</span>
    <h2 class="ce-section-title">Next Available Chelmsford Mocks</h2>
    <p class="ce-section-sub">These are the only two Chelmsford CSSE mocks currently open for booking. Every mock includes a full Cohort Report: Rank • Percentile • Standardised Score.</p>
    <div class="ce-table-wrap">
      <table class="ce-schedule">
        <thead>
          <tr><th></th><th>Date</th><th>Exam Type</th><th>Time</th><th>Venue</th><th>Price</th></tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of scheduleRows">
            <td><a [href]="row.bookUrl" class="ce-btn ce-btn-navy" style="padding:8px 16px;font-size:13px;">Book</a></td>
            <td>{{ row.date }}</td>
            <td><span class="ce-tag-csse">{{ row.type }}</span></td>
            <td>{{ row.time }}</td>
            <td>{{ row.venue }}</td>
            <td>{{ row.price }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="ce-swipe-hint"><i class="fa-solid fa-arrows-left-right"></i> Swipe to see full schedule</div>
    <a href="#ce-report" class="ce-view-all-link" (click)="scrollToReport($event)">View Sample Report <i class="fa-solid fa-arrow-right"></i></a>
  </div>
</section>

<!-- ===== WHY SEHYOG ===== -->
<section class="ce-section" style="background:var(--sh-surf);">
  <div class="ce-wrap ce-why-wrap">
    <div>
      <span class="ce-eyebrow"><i class="fa-solid fa-wand-magic-sparkles"></i> Why SEHYOG</span>
      <h2 class="ce-section-title">More Than Just a Mock Test</h2>
      <p class="ce-why-intro">Every SEHYOG mock is built to feel like the real thing — and to leave you with far more than a single number. Here's exactly what's included:</p>
      <ul class="ce-why-list">
        <li>Authentic CSSE &amp; FSCE-style papers</li>
        <li>Full exam-condition experience</li>
        <li>Cohort Performance Report — Rank • Percentile • Standardised Score</li>
        <li>Detailed Strengths, Gaps &amp; Performance Analysis</li>
        <li>Take the Question Paper Home</li>
        <li>Detailed Solutions &amp; Post-Mock Support</li>
      </ul>
      <div class="ce-why-statement">Don't just find out your child's score. Find out what they need to improve before exam day.</div>
    </div>
    <div class="ce-why-img">
      <img src="https://images.unsplash.com/photo-1565843248736-8c41e6db117b?auto=format&fit=crop&w=900&q=80" alt="English school child in a UK classroom reviewing 11+ mock exam feedback" loading="lazy">
    </div>
  </div>
</section>

<!-- ===== SAMPLE REPORT (signature element) ===== -->
<section class="ce-section ce-report-section" id="ce-report">
  <div class="ce-wrap">
    <span class="ce-eyebrow"><i class="fa-solid fa-chart-pie"></i> What You Receive</span>
    <h2 class="ce-section-title">What Will I Learn From My Child's Mock?</h2>
    <p class="ce-section-sub">Every SEHYOG mock is designed to answer the question parents really want to know — <strong style="color:var(--sh-d);">"Is my child on track?"</strong></p>

    <div class="ce-report-card">
      <div class="ce-report-head">
        <div>
          <h3>Sample Cohort Performance Report</h3>
          <small>CSSE 11+ Mock · Chelmsford Centre</small>
        </div>
        <span class="ce-report-id">Anonymised Sample</span>
      </div>
      <div class="ce-report-body">
        <div class="ce-report-top ce-report-top-4">
          <div class="ce-report-stat">
            <div class="ce-ring-big ce-r76"><span>76%</span></div>
            <label>Overall Score</label>
          </div>
          <div class="ce-report-stat">
            <div class="ce-ring-big ce-rank-circ"><span>24/183</span></div>
            <label>Cohort Rank</label>
          </div>
          <div class="ce-report-stat">
            <div class="ce-ring-big ce-r87"><span>87th</span></div>
            <label>Percentile</label>
          </div>
          <div class="ce-report-stat">
            <div class="ce-ring-big ce-rss"><span>121</span></div>
            <label>Standardised Score</label>
          </div>
        </div>
        <table class="ce-report-table">
          <thead><tr><th>Section</th><th>Result</th></tr></thead>
          <tbody>
            <tr><td>English</td><td>72%</td></tr>
            <tr><td>Maths</td><td>81%</td></tr>
            <tr><td>Timing</td><td><span class="ce-badge-warn">Needs improvement</span></td></tr>
            <tr><td>Key Gap</td><td><span class="ce-badge-ok">Comprehension: Inference</span></td></tr>
          </tbody>
        </table>
        <p class="ce-report-quote">See Where Your Child Stands. Know What to Improve.</p>
      </div>
    </div>
  </div>
</section>

<!-- ===== REVIEWS ===== -->
<section class="ce-section" id="ce-reviews" style="background:var(--sh-surf);">
  <div class="ce-wrap">
    <span class="ce-eyebrow"><i class="fa-solid fa-comment-dots"></i> Parent Reviews</span>
    <h2 class="ce-section-title">Trusted by Chelmsford &amp; Essex Families</h2>
    <div class="ce-rating-strip">
      <span class="ce-stars"><i class="fa-solid fa-star" *ngFor="let s of stars"></i></span>
      4.9 out of 5 · based on 214 Google reviews
    </div>
    <div class="ce-review-grid">
      <div class="ce-review-card" *ngFor="let review of reviews">
        <div class="ce-stars">
          <i class="fa-solid fa-star" *ngFor="let s of stars"></i>
        </div>
        <p>"{{ review.quote }}"</p>
        <div class="ce-review-who">
          <div class="ce-review-avatar">{{ review.initial }}</div>
          <div><strong>{{ review.name }}</strong><small>{{ review.context }}</small></div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ===== PATHWAYS ===== -->
<section class="ce-section" id="ce-pathways">
  <div class="ce-wrap">
    <span class="ce-eyebrow"><i class="fa-solid fa-route"></i> Choose Your Pathway</span>
    <h2 class="ce-section-title">CSSE or CCHS — Which Mock Do I Need?</h2>
    <p class="ce-section-sub">Two clear pathways, so you only see what's relevant to your child's application.</p>
    <div class="ce-path-grid">
      <div class="ce-path-card ce-csse">
        <i class="fa-solid fa-landmark ce-path-icon"></i>
        <h3>CSSE 11+ Mocks</h3>
        <p>For KEGS, CRGS, Westcliff, Southend and other Essex CSSE consortium schools. Full-length CSSE-format paper under real exam conditions.</p>
        <a href="https://www.sehyog.co.uk/11plus-mock-test" class="ce-btn ce-btn-outline">View CSSE Mock Dates <i class="fa-solid fa-arrow-right"></i></a>
      </div>
      <div class="ce-path-card ce-cchs">
        <i class="fa-solid fa-building-columns ce-path-icon"></i>
        <h3>CCHS / FSCE Mocks</h3>
        <p>For Chelmsford County High School for Girls. Full-length FSCE-format paper, marked and ranked against the CCHS applicant cohort.</p>
        <a href="https://www.sehyog.co.uk/11plus-mock-test" class="ce-btn ce-btn-outline">View CCHS Mock Dates <i class="fa-solid fa-arrow-right"></i></a>
      </div>
    </div>
  </div>
</section>

<!-- ===== BUNDLES ===== -->
<section class="ce-section-tight" id="ce-bundles">
  <div class="ce-wrap">
    <div class="ce-bundle-box">
      <div>
        <h3>Planning multiple mocks?</h3>
        <p>Save with a Mock Series Package — sit 3 mocks across the term and track real progress mock-on-mock.</p>
      </div>
      <a href="https://www.sehyog.co.uk/11plus-mock-test" class="ce-btn ce-btn-bundle"><i class="fa-solid fa-tags"></i> View Mock Series Package</a>
    </div>
  </div>
</section>

<!-- ===== COMPARISON ===== -->
<section class="ce-section" style="background:var(--sh-surf);">
  <div class="ce-wrap">
    <span class="ce-eyebrow"><i class="fa-solid fa-scale-balanced"></i> Why It Matters</span>
    <h2 class="ce-section-title">A Typical Mock vs. a SEHYOG Mock</h2>
    <p class="ce-section-sub">A score alone doesn't tell you enough. Here's what a SEHYOG mock adds.</p>
    <div class="ce-compare-wrap">
      <table class="ce-compare">
        <thead>
          <tr><th></th><th class="ce-typ">Typical Mock</th><th class="ce-seh">SEHYOG Mock</th></tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of compareRows">
            <td>{{ row.label }}</td>
            <td><i [class]="row.typical ? 'fa-solid fa-check ce-yes' : 'fa-solid fa-minus ce-no'"></i></td>
            <td><i class="fa-solid fa-check ce-yes"></i></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</section>

<!-- ===== VENUE ===== -->
<section class="ce-section" id="ce-venue">
  <div class="ce-wrap ce-venue-wrap">
    <div>
      <span class="ce-eyebrow"><i class="fa-solid fa-building"></i> Venue Details</span>
      <h2 class="ce-section-title">Our Chelmsford Centre</h2>
      <p class="ce-section-sub" style="margin-bottom:0;">Located at St John Payne, Chelmsford — a quiet, structured environment designed for focused, exam-condition assessment.</p>
      <ul class="ce-venue-list">
        <li><span class="ce-v-ic"><i class="fa-solid fa-location-dot"></i></span><span class="ce-v-txt"><b>Address</b><span>St John Payne Catholic School, New North Road, Chelmsford, Essex</span></span></li>
        <li><span class="ce-v-ic"><i class="fa-solid fa-car"></i></span><span class="ce-v-txt"><b>Parking</b><span>Free on-site parking available on mock days</span></span></li>
        <li><span class="ce-v-ic"><i class="fa-solid fa-clock"></i></span><span class="ce-v-txt"><b>Arrival Time</b><span>Please arrive 15 minutes before the sitting time</span></span></li>
        <li><span class="ce-v-ic"><i class="fa-solid fa-person-walking"></i></span><span class="ce-v-txt"><b>Public Transport</b><span>5 minute walk from Chelmsford bus routes</span></span></li>
      </ul>
    </div>
    <div class="ce-venue-map">
      <img src="https://images.unsplash.com/photo-1591123120675-6f7f1aae0e5b?auto=format&fit=crop&w=900&q=80" alt="SEHYOG Chelmsford 11+ mock exam centre exterior" loading="lazy">
    </div>
  </div>
</section>

<!-- ===== FAQ ===== -->
<section class="ce-section" id="ce-faq" style="background:var(--sh-surf);">
  <div class="ce-wrap" style="max-width:820px;">
    <span class="ce-eyebrow"><i class="fa-solid fa-circle-question"></i> Common Questions</span>
    <h2 class="ce-section-title">Frequently Asked Questions</h2>

    <div class="ce-faq-item" [class.ce-open]="faq.open" *ngFor="let faq of faqs; let i = index">
      <div class="ce-faq-q" (click)="toggleFaq(i)">{{ faq.question }} <i class="fa-solid fa-plus"></i></div>
      <div class="ce-faq-a" [style.maxHeight]="faq.open ? '400px' : '0px'"><p>{{ faq.answer }}</p></div>
    </div>
  </div>
</section>

<!-- ===== FINAL CTA ===== -->
<section class="ce-final-cta">
  <div class="ce-wrap">
    <h2>Ready to see where your child stands?</h2>
    <p>Book your next Chelmsford 11+ mock and get a real score, a real rank, and a clear plan before exam day.</p>
    <a href="https://www.sehyog.co.uk/11plus-mock-test" class="ce-btn ce-btn-primary"><i class="fa-solid fa-calendar-check"></i> View Available Mocks</a>
  </div>
</section>

<!-- Sticky mobile CTA -->
<div class="ce-sticky-cta">
  <div class="ce-price">From £30 <small>Next mock: Sat 29 Aug</small></div>
  <a href="https://www.sehyog.co.uk/11plus-mock-test" class="ce-btn ce-btn-primary" style="padding:12px 22px;font-size:14px;">Book Mock →</a>
</div>

